import { RecipientTypeEnum } from "../enums/RecipientTypeEnum";
import i18n from "../../services/localization-service/i18n";

export function getRecipientTypeName(recipientType: RecipientTypeEnum) {
    return recipientType === RecipientTypeEnum.Email
        ? i18n.t("enums.recipientType.email")
        : recipientType === RecipientTypeEnum.Text
            ? i18n.t("enums.recipientType.text")
            : recipientType === RecipientTypeEnum.Voice
                ? i18n.t("enums.recipientType.voice")
                : i18n.t("enums.recipientType.invalid");
}
